"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EPurchasePortalStatus = void 0;
var EPurchasePortalStatus;
(function (EPurchasePortalStatus) {
    EPurchasePortalStatus["Ready"] = "Ready";
    EPurchasePortalStatus["Initializing"] = "Initializing";
})(EPurchasePortalStatus = exports.EPurchasePortalStatus || (exports.EPurchasePortalStatus = {}));
//# sourceMappingURL=EPurchasePortalStatus.js.map